"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureGroupTypes = void 0;
var MeasureGroupTypes;
(function (MeasureGroupTypes) {
    MeasureGroupTypes["INTERMEDIATE_OUTCOME"] = "Intermediate Outcome";
    MeasureGroupTypes["OUTCOME"] = "Outcome";
    MeasureGroupTypes["PATIENT_REPORTED_OUTCOME"] = "Patient Reported Outcome";
    MeasureGroupTypes["PROCESS"] = "Process";
    MeasureGroupTypes["STRUCTURE"] = "Structure";
})(MeasureGroupTypes = exports.MeasureGroupTypes || (exports.MeasureGroupTypes = {}));
